import React from 'react';
import {View, Text, TouchableOpacity} from 'react-native';
import {Color, globalFontStyle} from '../../../assets';
import FastImage from '../../../common/FastImage';
import {order_yes_contract, txn_success} from '../../../utils/images';

const CouponSuccessScreen = ({dataObj, onOkayClick}) => {
  return (
    <View style={{alignItems: 'center', padding: 35, paddingBottom: 0}}>
      <FastImage
        style={{width: 50, height: 50, marginBottom: 15}}
        source={order_yes_contract()}
      />
      <Text style={[globalFontStyle.appFontSmallText, {color: Color.green}]}>
        '{dataObj?.coupon}' applied
      </Text>
      <Text style={[globalFontStyle.appFontHeading, {marginTop: 8}]}>
        {dataObj?.msg}
      </Text>
      <Text style={[globalFontStyle.appFontSmallText, {marginTop: 8}]}>
        with this coupon code
      </Text>
      <TouchableOpacity onPress={onOkayClick}>
        <Text
          style={[
            globalFontStyle.appFontSmallText,
            {color: Color.tradexBlue, marginTop: 30},
          ]}>
          Woohoo! Thanks
        </Text>
      </TouchableOpacity>
    </View>
  );
};

export default CouponSuccessScreen;
